module.exports = __webpack_public_path__ + "img/info.9b3a3df2.svg";